export const SGPBadgeDark = {
    fillBackground: "none",
    fill: "#53D337"
};
export const SGPBadgeLight = {
    fillBackground: "#F1FBEE",
    fill: "#2A751A"
};
//# sourceMappingURL=SGPBadge.js.map